import { CSSProperties, forwardRef } from 'react';
import { Control, FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import FiscalRegimeSelect from '../inputs/Select/FiscalRegimeSelect';

interface Props<T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>> {
  className?: string;
  control: Control<T>;
  disabled?: boolean;
  helperText?: string;
  label: string;
  name: TName;
  required?: boolean;
  rules?: UseControllerProps<T, TName>['rules'];
  style?: CSSProperties;
}
interface WithForwardRefTypeProps<
  T extends FieldValues = FieldValues,
  TName extends FieldPath<T> = FieldPath<T>,
> extends React.FC<Props<T, TName>> {
  <T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>>(
    props: Props<T, TName>,
  ): ReturnType<React.FC<Props<T, TName>>>;
}

const FiscalRegimeController: WithForwardRefTypeProps = forwardRef(
  (
    { className, control, disabled, helperText, label, name, required, rules, style },
    ref?: React.Ref<HTMLDivElement>,
  ) => {
    const { field, fieldState } = useController({ name, control, rules });
    return (
      <FiscalRegimeSelect
        {...field}
        ref={ref}
        className={className}
        isDisabled={disabled}
        label={label}
        isRequired={required}
        isInvalid={fieldState.invalid}
        errorMessage={fieldState.error?.message}
        helpText={helperText}
        style={style}
      />
    );
  },
);

export default FiscalRegimeController;
